const translations = {
  en: {
    sidebar: {
      title: "Coord App",
      newConversation: "New Conversation",
      home: "Home",
      conversations: "Conversations",
      resources: "Resources",
      logout: "Logout",
      signIn: "Sign in",
      signUp: "Sign Up",
    },
    footer: {
      about: "About",
      privacy: "Privacy",
      salesTerms: "Terms of Sale",
      contact: "Contact",
    },
    consent: {
      message: "We use cookies for visitor statistics and store which campaign or link brought you here, so we can make Coord better. The choice is yours.",
      accept: "Accept",
      decline: "Decline",
      privacyLink: "Read more in the privacy policy",
      ariaLabel: "Cookie consent",
    },
    home: {
      welcome: "Welcome to the Coord App",
      subtitle: "Your child has been diagnosed. Now what?",
      description: "Coord is your AI-powered conversation assistant that helps you on your journey.",
    },
    dashboard: {
      greetings: {
        morning: "Good morning",
        day: "Good day",
        evening: "Good evening"
      },
      latestConversations: "Latest Conversations",
      noConversations: "No conversations yet.",
      startNewConversation: "Start a new conversation",
      suggestedQuestions: {
        title: "What would you like to know?",
        q1: "What treatment or support measures are available?",
        q2: "What help can we get from the school or kindergarten?",
        q3: "Are there support groups or resources for parents in the same situation?",
        q4: "How can we best support the child's development at home?",
        q5: "What are the most common challenges we may face in the future?"
      },
      todoList: "Todo List",
      todoListPlaceholder: "Todo list content will go here."
    },
    conversations: {
      myConversations: "My Conversations",
      createNewConversation: "Create a new conversation",
      latestActivity: "Latest activity",
      seeAllConversations: "See all conversations",
      createNewCollection: "Create a new collection",
      emptyStateMessage: "You have no conversations yet.",
      emptyStateCta: "Start a new conversation"
    },
    newConversation: {
      title: "Start a new conversation",
      suggestedQuestions: {
        q1: "What treatment or support measures are available?",
        q2: "What help can we get from the school or kindergarten?",
        q3: "Are there support groups or resources for parents in the same situation?",
        q4: "Is there an overview of what rights we have?"
      }
    },
    resources: {
      title: "Resources",
      description: "This page will display useful resources like templates and handbooks. This is a placeholder for now."
    },
    about: {
      title: "About Us",
      description: "This is where you would describe your team and the mission behind the service."
    },
    privacy: {
      title: "Privacy Policy",
      description: "This page will contain your privacy policy information."
    },
    contact: {
      title: "Contact Us",
      description: "This is where you would provide contact details for users to reach out."
    },
    collectionsList: {
      collections: "Collections",
      subtitle: "Organize your conversations",
      noCollections: "No collections found.",
      conversationsLabel: (count) => count === 1 ? "conversation" : "conversations",
    },
    authPopup: {
      welcome: "Welcome",
      message: "Sign in or sign up to continue",
      continueWithVipps: "Continue with Vipps",
      cancel: "Cancel"
    },
    createCollectionPopup: {
      title: "Create Collection",
      subtitle: "Organize and group your conversations",
      namePlaceholder: "Title",
      descriptionPlaceholder: "Description",
      cancel: "Cancel",
      create: "Create",
    },
    editCollectionPopup: {
      title: "Edit Collection",
      namePlaceholder: "Collection name",
      descriptionPlaceholder: "Collection description",
      update: "Update",
      cancel: "Cancel",
    },
    editConversationPopup: {
      title: "Edit Conversation",
      titlePlaceholder: "Conversation title",
      update: "Update",
      cancel: "Cancel",
    },
    conversationDropdown: {
        addToCollection: "Add to collection",
        editTitle: "Edit title",
        deleteConversation: "Delete conversation"
      },
    messageInput: {
      placeholder: "Type your message...",
      send: "Send",
    },
    common: {
      user: "User",
      loading: "Loading...",
      error: "An error occurred. Please try again.",
      // ... (other common translations)
    },
    deleteConfirmationPopup: {
      title: "Confirm Deletion",
      message: "Are you sure you want to delete this collection? This action cannot be undone.",
      cancel: "Cancel",
      delete: "Delete"
    },
    deleteConversationPopup: {
      title: "Confirm Deletion",
      message: "Are you sure you want to delete this conversation?",
      cancel: "Cancel",
      delete: "Delete"
    },
    subscription: {
      title: "Subscribe to Coord",
      intro: "Guidance on your family's rights, an overview of Nav benefits, and ready-to-send application drafts — all in one place.",
      perMonth: "per month",
      vatIncluded: "VAT included",
      cancelAnytime: "No lock-in — cancel whenever you like.",
      consentTermsPrefix: "I have read and accept the ",
      consentTermsLink: "terms of sale",
      consentWithdrawal: "I consent to the service being delivered immediately, and that the right of withdrawal therefore applies proportionally for the period up until I choose to exercise it, cf. the Norwegian Cancellation Act (angrerettloven).",
      consentHealthText: "I consent to Coord processing health information I provide about myself and my child, in order to give guidance and prepare application drafts. I can withdraw my consent at any time and delete all data under Account. Read more in the",
      consentHealthLink: "privacy policy",
      startButton: "Start subscription with Vipps",
      starting: "Sending you to Vipps …",
      errorVipps: "We could not reach Vipps just now. No payment has been made. Please try again in a moment.",
      errorGeneric: "Something went wrong. No payment has been made. Please try again.",
      retry: "Try again",
      alreadyActive: "Your subscription is already active.",
      activeButLapsed: "The payment failed and access is closed. Go to Account → Subscription to sort out the subscription.",
      manageLink: "Manage your subscription under Account",
      accountHint: "Want to manage or delete your data? Go to",
      accountHintLink: "Account"
    },
    subscriptionConfirm: {
      waitingTitle: "Confirming your subscription …",
      waitingBody: "We are waiting for confirmation from Vipps. This usually takes just a few seconds.",
      successTitle: "Your subscription is active!",
      successBody: "You will find the receipt in the Vipps app.",
      successCta: "Get started",
      failedTitle: "The payment was not completed",
      failedBody: "The agreement was not completed in Vipps, and no subscription has been created. You are welcome to try again.",
      timeoutTitle: "Still waiting for Vipps",
      timeoutBody: "We have not received a confirmation yet. If you approved the agreement in Vipps, wait a moment and reload this page — or try again.",
      tryAgain: "Try again"
    },
    accountSubscription: {
      tabTitle: "Subscription",
      heading: "Subscription",
      statusTitle: "Your subscription",
      statusLabel: "Status",
      statusActive: "Active",
      statusStopped: "Stopped",
      statusPending: "Awaiting confirmation",
      statusExpired: "Expired",
      statusNone: "No subscription",
      statusLapsedPaymentFailed: "Expired – payment failed",
      statusPaymentProblemUntil: "Payment problem – access until",
      statusPaymentProblem: "Payment problem",
      statusStoppedUntil: "Stopped – access until",
      statusExpiredUntil: "Expired – access until",
      statusEnded: "Ended",
      paymentProblemNote: "The last payment failed. We retry automatically – check your payment method in the Vipps app.",
      lapsedNote: "The payment failed and access is closed. Cancel the subscription and start it again to regain access.",
      priceLabel: "Price",
      perMonth: "per month (VAT incl.)",
      nextCharge: "Next charge",
      accessUntil: "Access until",
      vippsNote: "You can also manage the agreement in the Vipps app.",
      cancelButton: "Cancel subscription",
      cancelling: "Cancelling …",
      cancelConfirm: "Are you sure you want to cancel the subscription?",
      cancelConfirmUntil: "You keep access until",
      cancelDialogTitle: "Cancel subscription",
      cancelDialogConfirm: "Yes, cancel",
      cancelDialogKeep: "Keep subscription",
      cancelFailed: "We could not cancel the subscription. Please try again, or manage the agreement in the Vipps app.",
      cancelReasonTitle: "Before you go – why are you cancelling?",
      cancelReasonGranted: "We were granted the benefit we applied for",
      cancelReasonTooExpensive: "It got too expensive",
      cancelReasonUnmetNeed: "I didn't get what I needed",
      cancelReasonOther: "Other",
      cancelReasonTextLabel: "Tell us more (optional)",
      cancelReasonCharsLeft: "characters left",
      cancelReasonContinue: "Continue",
      cancelReasonSkip: "Skip",
      cancelReasonClose: "Close",
      goodbyeAccessUntil: "You have access until",
      goodbyeGrantedLead: "Congratulations on the granted benefit!",
      goodbyeGrantedTail: "Coord is here if you face a new crossroads – an appeal, a reassessment, a new application or a change of school. Welcome back any time.",
      goodbyeTooExpensiveLead: "Thank you for your time with us.",
      goodbyeTooExpensiveTail: "Welcome back any time.",
      goodbyeUnmetNeedLead: "Thank you for trying Coord.",
      goodbyeUnmetNeedTail: "Your feedback helps us improve.",
      goodbyeDefaultLead: "The subscription is cancelled.",
      goodbyeDefaultTail: "Welcome back any time.",
      subscribeLink: "Start subscription",
      staffAccessTitle: "Staff access",
      staffAccessNote: "You have full access without a subscription.",
      historyTitle: "Payment history",
      historyLoading: "Loading payments …",
      historyError: "We could not load your payment history. Please try again later.",
      historyEmpty: "No payments yet.",
      colDate: "Date",
      colAmount: "Amount",
      colStatus: "Status",
      chargeStatus: {
        CHARGED: "Charged",
        RESERVED: "Reserved",
        DUE: "Due",
        PENDING: "Processing",
        PROCESSING: "Processing",
        FAILED: "Failed",
        CANCELLED: "Cancelled",
        REFUNDED: "Refunded",
        PARTIALLY_REFUNDED: "Partially refunded",
        PARTIALLY_CAPTURED: "Partially charged"
      }
    },
  },
  no: {
    sidebar: {
      title: "Coord App",
      newConversation: "Ny Samtale",
      home: "Hjem",
      conversations: "Samtaler",
      resources: "Ressurser",
      logout: "Logg ut",
      signIn: "Logg inn",
      signUp: "Registrer deg",
    },
    footer: {
      about: "Om oss",
      privacy: "Personvern",
      salesTerms: "Salgsvilkår",
      contact: "Kontakt",
    },
    consent: {
      message: "Vi bruker informasjonskapsler til besøksstatistikk og lagrer hvilken kampanje eller lenke som førte deg hit, slik at vi kan gjøre Coord bedre. Du velger selv.",
      accept: "Godta",
      decline: "Avslå",
      privacyLink: "Les mer i personvernerklæringen",
      ariaLabel: "Samtykke til informasjonskapsler",
    },
    home: {
      welcome: "Velkommen til Coord Appen",
      subtitle: "Ditt barn har fått en diagnose. Hva nå?",
      description: "Coord er din AI-drevne samtaleassistent som hjelper deg på reisen.",
    },
    dashboard: {
      greetings: {
        morning: "God morgen",
        day: "God dag",
        evening: "God kveld"
      },
      latestConversations: "Siste samtaler",
      noConversations: "Ingen samtaler ennå.",
      startNewConversation: "Start en ny samtale",
      suggestedQuestions: {
        title: "Hva lurer du på?",
        q1: "Hvilke behandlings- eller støttetiltak er tilgjengelige?",
        q2: "Hvilken hjelp kan vi få fra skolen eller barnehagen?",
        q3: "Finnes det støttegrupper eller ressurser for foreldre i samme situasjon?",
        q4: "Hvordan kan vi best støtte barnets utvikling hjemme?",
        q5: "Hva er de vanligste utfordringene vi kan møte fremover?"
      },
      todoList: "Huskeliste",
      todoListPlaceholder: "Innhold for huskelisten vil vises her."
    },
    conversations: {
      myConversations: "Mine samtaler",
      createNewConversation: "Opprett en ny samtale",
      latestActivity: "Siste aktivitet",
      seeAllConversations: "Se alle samtaler",
      createNewCollection: "Opprett en ny samling",
      emptyStateMessage: "Du har ingen samtaler ennå.",
      emptyStateCta: "Start en ny samtale"
    },
    newConversation: {
      title: "Start en ny samtale",
      suggestedQuestions: {
        q1: "Hvilke behandlings- eller støttetiltak er tilgjengelige?",
        q2: "Hvilken hjelp kan vi få fra skolen eller barnehagen?",
        q3: "Finnes det støttegrupper eller ressurser for foreldre i samme situasjon?",
        q4: "Finnes det en oversikt over hvilke rettigheter vi har?"
      }
    },
    resources: {
      title: "Ressurser",
      description: "Her finner du nyttige ressurser til deg som vil hjelpe deg med å forstå rettigheter og muligheter for barnet ditt."
    },
    about: {
      title: "Om oss",
      description: "Her ville du beskrevet teamet ditt og misjonen bak tjenesten."
    },
    privacy: {
      title: "Personvernerklæring",
      description: "Denne siden vil inneholde informasjon om personvernerklæringen din."
    },
    contact: {
      title: "Kontakt oss",
      description: "Her ville du gitt kontaktinformasjon for brukere som ønsker å ta kontakt."
    },
    collectionsList: {
      collections: "Samlinger",
      subtitle: "Organiser samtalene dine",
      noCollections: "Ingen samlinger funnet.",
      conversationsLabel: (count) => count === 1 ? "samtale" : "samtaler",
    },
    authPopup: {
      welcome: "Velkommen",
      message: "Logg inn eller registrer deg for å fortsette",
      continueWithVipps: "Fortsett med Vipps",
      cancel: "Avbryt"
    },
    createCollectionPopup: {
      title: "Opprett ny samling",
      subtitle: "Organiser og grupper samtalene dine",
      namePlaceholder: "Samlingens navn",
      descriptionPlaceholder: "Samlingens beskrivelse (valgfritt)",
      create: "Opprett",
      cancel: "Avbryt",
    },
    editCollectionPopup: {
      title: "Rediger samling",
      namePlaceholder: "Samlingens navn",
      descriptionPlaceholder: "Samlingens beskrivelse",
      update: "Oppdater",
      cancel: "Avbryt",
    },
    editConversationPopup: {
      title: "Rediger samtale",
      titlePlaceholder: "Samtalens tittel",
      update: "Oppdater",
      cancel: "Avbryt",
    },
    conversationDropdown: {
        addToCollection: "Legg til i samling",
        editTitle: "Rediger tittel",
        deleteConversation: "Slett samtale"
      },
    messageInput: {
      placeholder: "Skriv inn din melding...",
      send: "Send",
    },
    common: {
      user: "Bruker",
      loading: "Laster...",
      error: "En feil oppstod. Vennligst prøv igjen.",
      // ... (other common translations)
    },
    deleteConfirmationPopup: {
      title: "Bekreft sletting",
      message: "Er du sikker på at du vil slette denne samlingen? Denne handlingen kan ikke angres.",
      cancel: "Avbryt",
      delete: "Slett"
    },
    deleteConversationPopup: {
      title: "Bekreft sletting",
      message: "Er du sikker på at du vil slette denne samtalen?",
      cancel: "Avbryt",
      delete: "Slett"
    },
    subscription: {
      title: "Abonnement på Coord",
      intro: "Veiledning om familiens rettigheter, oversikt over Nav-stønader og ferdige søknadsutkast – alt på ett sted.",
      perMonth: "per måned",
      vatIncluded: "inkl. mva.",
      cancelAnytime: "Ingen bindingstid – du kan si opp når som helst.",
      consentTermsPrefix: "Jeg har lest og godtar ",
      consentTermsLink: "salgsvilkårene",
      consentWithdrawal: "Jeg samtykker til at tjenesten leveres umiddelbart, og at angreretten dermed gjelder forholdsmessig for perioden frem til jeg eventuelt benytter den, jf. angrerettloven.",
      consentHealthText: "Jeg samtykker til at Coord behandler helseopplysninger jeg oppgir om meg og barnet mitt, for å kunne gi veiledning og lage søknadsutkast. Jeg kan når som helst trekke samtykket tilbake og slette alle data under Konto. Les mer i",
      consentHealthLink: "personvernerklæringen",
      startButton: "Start abonnement med Vipps",
      starting: "Sender deg til Vipps …",
      errorVipps: "Vi fikk ikke kontakt med Vipps akkurat nå. Ingen betaling er gjennomført. Prøv igjen om et øyeblikk.",
      errorGeneric: "Noe gikk galt. Ingen betaling er gjennomført. Prøv igjen.",
      retry: "Prøv igjen",
      alreadyActive: "Abonnementet ditt er allerede aktivt.",
      activeButLapsed: "Betalingen feilet og tilgangen er stengt. Gå til Konto → Abonnement for å ordne abonnementet.",
      manageLink: "Administrer abonnementet under Konto",
      accountHint: "Vil du administrere eller slette dataene dine? Gå til",
      accountHintLink: "Konto"
    },
    subscriptionConfirm: {
      waitingTitle: "Bekrefter abonnementet ditt …",
      waitingBody: "Vi venter på bekreftelse fra Vipps. Dette tar vanligvis bare noen sekunder.",
      successTitle: "Abonnementet er aktivt!",
      successBody: "Kvitteringen finner du i Vipps-appen.",
      successCta: "Kom i gang",
      failedTitle: "Betalingen ble ikke fullført",
      failedBody: "Avtalen ble ikke fullført i Vipps, og det er ikke opprettet noe abonnement. Du kan gjerne prøve igjen.",
      timeoutTitle: "Vi venter fortsatt på Vipps",
      timeoutBody: "Vi har ikke fått bekreftelse ennå. Hvis du godkjente avtalen i Vipps, kan du vente litt og laste siden på nytt – eller prøve igjen.",
      tryAgain: "Prøv igjen"
    },
    accountSubscription: {
      tabTitle: "Abonnement",
      heading: "Abonnement",
      statusTitle: "Ditt abonnement",
      statusLabel: "Status",
      statusActive: "Aktiv",
      statusStopped: "Stoppet",
      statusPending: "Venter på bekreftelse",
      statusExpired: "Utløpt",
      statusNone: "Ingen abonnement",
      statusLapsedPaymentFailed: "Utløpt – betaling feilet",
      statusPaymentProblemUntil: "Betalingsproblem – tilgang til",
      statusPaymentProblem: "Betalingsproblem",
      statusStoppedUntil: "Stoppet – tilgang til",
      statusExpiredUntil: "Utløpt – tilgang til",
      statusEnded: "Avsluttet",
      paymentProblemNote: "Siste betaling feilet. Vi prøver igjen automatisk – sjekk betalingsmåten din i Vipps-appen.",
      lapsedNote: "Betalingen feilet, og tilgangen er stengt. Avslutt abonnementet og start det på nytt for å få tilgang igjen.",
      priceLabel: "Pris",
      perMonth: "per måned (inkl. mva.)",
      nextCharge: "Neste belastning",
      accessUntil: "Tilgang til",
      vippsNote: "Du kan også administrere avtalen i Vipps-appen.",
      cancelButton: "Avslutt abonnement",
      cancelling: "Avslutter …",
      cancelConfirm: "Er du sikker på at du vil avslutte abonnementet?",
      cancelConfirmUntil: "Du beholder tilgangen frem til",
      cancelDialogTitle: "Avslutt abonnement",
      cancelDialogConfirm: "Ja, avslutt",
      cancelDialogKeep: "Behold abonnementet",
      cancelFailed: "Vi fikk ikke avsluttet abonnementet. Prøv igjen, eller administrer avtalen i Vipps-appen.",
      cancelReasonTitle: "Før du går – hvorfor avslutter du?",
      cancelReasonGranted: "Vi fikk innvilget støtten vi søkte om",
      cancelReasonTooExpensive: "Det ble for dyrt",
      cancelReasonUnmetNeed: "Jeg fikk ikke det jeg trengte",
      cancelReasonOther: "Annet",
      cancelReasonTextLabel: "Fortell gjerne mer (valgfritt)",
      cancelReasonCharsLeft: "tegn igjen",
      cancelReasonContinue: "Fortsett",
      cancelReasonSkip: "Hopp over",
      cancelReasonClose: "Lukk",
      goodbyeAccessUntil: "Du har tilgang til",
      goodbyeGrantedLead: "Gratulerer så mye med innvilget støtte!",
      goodbyeGrantedTail: "Coord er her om dere står ved en ny korsvei – klage, revurdering, ny søknad eller skoleovergang. Velkommen tilbake når som helst.",
      goodbyeTooExpensiveLead: "Takk for tiden med oss.",
      goodbyeTooExpensiveTail: "Velkommen tilbake når som helst.",
      goodbyeUnmetNeedLead: "Takk for at du prøvde Coord.",
      goodbyeUnmetNeedTail: "Tilbakemeldingen din hjelper oss å bli bedre.",
      goodbyeDefaultLead: "Abonnementet er avsluttet.",
      goodbyeDefaultTail: "Velkommen tilbake når som helst.",
      subscribeLink: "Start abonnement",
      staffAccessTitle: "Personaltilgang",
      staffAccessNote: "Du har full tilgang uten abonnement.",
      historyTitle: "Betalingshistorikk",
      historyLoading: "Laster betalinger …",
      historyError: "Vi fikk ikke hentet betalingshistorikken. Prøv igjen senere.",
      historyEmpty: "Ingen betalinger ennå.",
      colDate: "Dato",
      colAmount: "Beløp",
      colStatus: "Status",
      chargeStatus: {
        CHARGED: "Belastet",
        RESERVED: "Reservert",
        DUE: "Forfaller",
        PENDING: "Under behandling",
        PROCESSING: "Under behandling",
        FAILED: "Mislykket",
        CANCELLED: "Kansellert",
        REFUNDED: "Refundert",
        PARTIALLY_REFUNDED: "Delvis refundert",
        PARTIALLY_CAPTURED: "Delvis belastet"
      }
    },
  },
};

export default translations;
